import {WithoutSummaryModel} from '../../../../common/entity/dto/plain/withoutSummary.model';
import {ReportComponentSummaryModel} from '../../../report-component/api/entity/reportComponentSummary.model';

export class ReportDefinitionComponentModel extends WithoutSummaryModel {
    index: number;
    reportComponent: ReportComponentSummaryModel;
}
